<template>
  <header class="banner-slide" :style="bannerStyle">
    <img
      class="banner-img"
      v-for="(item, index) in homeBanner"
      :key="index"
      :src="item.url"
      :alt="item.alt"
      @click="imgClick(item.destination);"
    />
  </header>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Banner",
  data() {
    return {
      curIndex: 0,
      timer: null,
      homeBanner: [
        {
          title: "尤果网拍摄预约",
          alt: "尤果网拍摄预约",
          url:
            // "https://material.youguoquan.com/material/banner-wz-1903281433.jpg",
            "/static/images/banner-wz-1903281433.jpg",
          // destination: "https://www.ugirl.com/help/about.html?1642141132706"
          destination: "/help/about.html"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      home: "homeData"
    }),
    bannerStyle() {
      return {
        transform: `translateX(${-this.curIndex * 100}%)`
      };
    }
  },
  methods: {
    asyncCurIndex() {
      if (this.curIndex < this.home.banner.length - 1) {
        this.curIndex++;
      } else {
        this.curIndex = 0;
      }
    },
    imgClick(url) {
      window.location.href = url;
    }
  },
  /*mounted() {
      this.timer = setInterval(this.asyncCurIndex, 3000);
    },*/
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/stylefunc";
.banner-slide {
  display: flex;
  align-items: center;
  transition: all 1s ease-in-out;
  .banner-img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue